module.exports = __webpack_public_path__ + "img/Face9.fe200002.jpg";